import React from 'react'
import ARCMetlinkReportComponent from '../Components/MetlinkReport/ARCMetlinkReportComponent' 

function ARCMetlinkReportPage() {
    return (
        <ARCMetlinkReportComponent/>
    )
}

export default ARCMetlinkReportPage